module.exports = __webpack_public_path__ + "img/loghomes.384a52c7.jpg";